import Input from './Input'
import InputField from './InputField'
import InputLabels from './InputLabels'

export default Input
export { InputField, InputLabels }
